module.exports = __webpack_public_path__ + "img/ce68d41.png";